module.exports = require('./helpers/bundle-url').getBundleURL('8g68e') + "training_img.ade380c1.webp";